/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Embed_Cv_Check_DescriptionInputs */

const en_admin_embed_cv_check_description = /** @type {(inputs: Admin_Embed_Cv_Check_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed the CV check so participants can have their CV reviewed directly on your website.`)
};

const de_admin_embed_cv_check_description = /** @type {(inputs: Admin_Embed_Cv_Check_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betten Sie den CV-Check ein, damit Teilnehmende ihren Lebenslauf direkt auf Ihrer Webseite prüfen lassen können.`)
};

/**
* | output |
* | --- |
* | "Embed the CV check so participants can have their CV reviewed directly on your website." |
*
* @param {Admin_Embed_Cv_Check_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_embed_cv_check_description = /** @type {((inputs?: Admin_Embed_Cv_Check_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Embed_Cv_Check_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_embed_cv_check_description(inputs)
	return en_admin_embed_cv_check_description(inputs)
});